import { connect } from 'react-redux'
import type { AppStateType } from '../../../../reducers/appstate'
import type { Dispatch } from 'redux'
import type { DispatchPropsType, PropsType } from './QuizResults'
import QuizResults from './QuizResults'
import { togglePromoModal } from '../../../../actions/promoActions'
import { openSubscribeConfirmed } from '../../../../actions/navigationActions'
import { isSubscribed } from '@components/subscribe/BillingInformation/selectors'

type OwnPropsType = {
  result: {
    id: string,
    tag?: string,
    genderPref?: string,
    display_name: string,
    description: string,
    image: string
  },
  resultHeader: string,
  existingResult?: string,
  triggerConversionEvent: () => void
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): PropsType => {
  return {
    resultHeader: ownProps.resultHeader,
    image: ownProps.result.image,
    name: ownProps.result.display_name,
    description: ownProps.result.description,
    isSubscribed: isSubscribed(state),
    existingResult: ownProps.existingResult,
    triggerConversionEvent: (): void => ownProps.triggerConversionEvent()
  } as PropsType
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    openSubscribeModal: (): void => dispatch(togglePromoModal()),
    openDriveToDownload: (): void => dispatch(openSubscribeConfirmed(true))
  } as DispatchPropsType
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizResults)
